const mEditionMapPathModalCreateStep = {
  mEditionMapPathModalCreateStep: {
    alerts: {
      createContenidoNodo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El nuevo paso fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 255 caracteres'
      }
    },

    title: 'Nuevo Paso',

    validation: {
      nodo: {
        nombre: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de paso es requerido.'
        }
      }
    }
  }
}

export default mEditionMapPathModalCreateStep
